import React from "react";
import PropTypes from "prop-types";
import "../../../styles/buttonLink.scss";

const ButtonLink = ({ content, ...props }) => {
  return (
    <div className="blink" {...props}>
      {content}
    </div>
  );
};

ButtonLink.propTypes = {
  content: PropTypes.string.isRequired,
};

export default ButtonLink;
